import { BudgetTemplate } from 'interfaces/BudgetTemplate';
import { RepositoryParams, api } from '..';

export type BudgetTemplateFilters = Partial<BudgetTemplate & RepositoryParams>;

export const list = async () => {
  return api.get('/modelos-budget');
};

export const listAll = async (params: BudgetTemplateFilters) => {
  return api.get('/modelos-budget/all', { params });
};

export const create = async (params: BudgetTemplate) => {
  return api.post('/modelos-budget', { ...params });
};

export const update = async (params: BudgetTemplate) => {
  return api.patch(`/modelos-budget/${params.id}`, { ...params });
};

export const retrieve = async (id: string) => {
  return api.get(`/modelos-budget/${id}`);
};

export const remove = async (id: string) => {
  return api.delete(`/modelos-budget/${id}`);
};
